export const Marquee = ({ t }) => {
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div data-testid="marquee-ribbon" className="relative border-y border-[#D4AF37]/15 bg-[#111A2E] py-5 overflow-hidden">
      <div className="marquee-track flex items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-lg text-slate-300 italic">{item}</span>
            <span className="text-[#D4AF37] text-xs">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
